var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RsJobLog',{attrs:{"id":_vm.id,"seconds":_vm.seconds,"jobGroup":_vm.jobGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }